import React, { FC } from "react";

const Component404: FC<any> = () => {
  return <div>Page not found</div>;
};

export default Component404;
